import {useState} from 'react';
import {Resizable} from 're-resizable';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {grey} from "@mui/material/colors";

import ContentViewPanel from './ContentViewPanel';

const WHITE_BACKGROUND_COLOR = '#FFFFFF';

const popOutDialogStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 5,
    background: WHITE_BACKGROUND_COLOR,
};

const popOutCloseButtonStyle = {
    backgroundColor: WHITE_BACKGROUND_COLOR,
    borderRadius: '0.25rem',
    position: 'absolute',
    right: '0.2rem',
    top: '0.3rem',
    '&:hover': {
        backgroundColor: grey[300]
    }
};

export default function PopOutDialog({
    isOpen,
    dialogSize,
    onDialogSizeChange,
    onClose,
    pdfUrl,
    pdfName,
    entraAuthentication
}) {
    const [isResizing, setIsResizing] = useState(false);

    if (!isOpen) {
        return null;
    }

    const handleResizeStart = () => {
        setIsResizing(true);
    };

    const handleResizeStop = (resizeEvent, resizeDirection, resizedElement, sizeChange) => {
        setIsResizing(false);
        onDialogSizeChange({
            width: dialogSize.width + sizeChange.width,
            height: dialogSize.height + sizeChange.height,
        });
    };

    return (
        <Resizable
            size={{width: dialogSize.width, height: dialogSize.height}}
            onResizeStart={handleResizeStart}
            onResizeStop={handleResizeStop}
            minWidth={'20vw'}
            minHeight={'20vh'}
            style={popOutDialogStyle}>
            <Box sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                pointerEvents: isResizing ? 'none' : 'auto'}}>
                <IconButton
                    onClick={onClose}
                    size='small'
                    sx={popOutCloseButtonStyle}
                    title="Close">
                    <CloseIcon fontSize="small"/>
                </IconButton>
                <ContentViewPanel
                    clickedPdfUrl={pdfUrl}
                    clickedPdfName={pdfName}
                    isResizing={isResizing}
                    entraAuthentication={entraAuthentication}/>
            </Box>
        </Resizable>
    );
}